module.exports = __webpack_public_path__ + "1f0ef66b757faedd81aefeb52793edf1.png";